import React from "react";
import { AI_ASSISTANT_CONSTANTS } from "../../constants/aiAssistantConstants";
import "./IntroWelcomeMessage.scss";

const IntroWelcomeMessage = () => {
  const { TITLE, VERSION } = AI_ASSISTANT_CONSTANTS.CHAT;
  return (
    <li
      className="msg-text align-left show intro-welcome-message-row"
      aria-label="Assistant welcome message"
    >
      <div className="Harris">
        <div className="markupdiv">
          <div className="message-content intro-welcome-message">
            <p className="intro-welcome-message__headline">
              <strong>
                Meet {TITLE}. {VERSION}.
              </strong>
            </p>

            <p className="intro-welcome-message__paragraph">
              We added a new analyst to your account. It knows your data, never needs to be briefed, works 24/7, and its name is {TITLE}.
            </p>

            <p className="intro-welcome-message__paragraph">
              Ask {TITLE} to pull brand metrics, build audience filters, run competitive comparisons, search recent news, or summarize what's on your screen.
            </p>

            <p className="intro-welcome-message__anchor">
              <strong>No menus. No exports. No waiting. Just ask.</strong>
            </p>

            <p className="intro-welcome-message__paragraph">
              <strong>Two modules aren't yet supported — Profile (100% stacked bar) and Exclusive Questions.</strong> Both are coming in the next version.
            </p>

            <p className="intro-welcome-message__anchor">
              <strong>The rest is live now.</strong>
            </p>

            <p className="intro-welcome-message__paragraph">
              For years, the biggest barrier to brand intelligence wasn't data. <strong>It was access.</strong>
            </p>

            <p className="intro-welcome-message__paragraph">
              Too many steps between a question and an answer. <strong>{TITLE} closes that gap.</strong>
            </p>

            <p className="intro-welcome-message__paragraph">
              The interface is no longer the obstacle. <strong>Now it's your analyst.</strong>
            </p>
          </div>
        </div>
      </div>
    </li>
  );
};

export default IntroWelcomeMessage;
